export const paths = {
  index: '/',
  login: '/login',
} as const
